import { axios } from '../../clients/axios'
import nodeFormData from 'form-data'
import { dayjs, MMDDYYYY } from '../../util/date'

const announcementHeaders = [
  { value: 'announcementId', text: 'Ticket ID' },
  { value: 'subject', text: 'Subject' },
  { value: 'message', text: 'message' },
  { value: 'startDate', text: 'Start Date' },
  { value: 'endDate', text: 'End Date' },
  { value: 'attachments', text: 'Attachments' },
  { value: 'status', text: 'Status' },
  { value: 'actions', text: 'Actions' }
]

export default {
  namespaced: true,
  state: {
    announcements: []
  },
  getters: {
    getAnnouncements: (state) => {
      return state.announcements.map((raw) => {
        raw.startDate = dayjs(raw.startDate).format(MMDDYYYY)
        raw.endDate = dayjs(raw.endDate).format(MMDDYYYY)

        return raw
      })
    },
    getHeaders: () => {
      return announcementHeaders.map((header) => {
        header.align = 'left'
        header.sortable = true

        return header
      })
    }
  },
  mutations: {
    fetchAnnouncements(state, announcements) {
      state.announcements = announcements
    },
    fetchCount(state, count) {
      state.count = count
    }
  },
  actions: {
    async fetchAnnouncementsAction(context, params) {
      const { page, limit, sortBy, sortDesc, search, statuses } = params
      let uri = `${
        process.env.VUE_APP_API_URL
      }/announcements/search?limit=${limit}&page=${page - 1}`

      if (sortBy) {
        uri += `&sortBy=${JSON.stringify(sortBy)}`
      }
      if (sortDesc) {
        uri += `&sortDesc=${JSON.stringify(sortDesc)}`
      }
      if (search) {
        uri += `&search=${JSON.stringify(search)}`
      }
      if (statuses) {
        uri += `&status=${JSON.stringify(statuses)}`
      }
      const announcements = await axios.get(uri, { withCredentials: true })

      context.commit('fetchAnnouncements', announcements.data.data)

      return { data: announcements.data.data, count: announcements.data.count }
    },
    async newAnnouncementAction(context, params) {
      try {
        const form = new nodeFormData()
        const { subject, message, startDate, endDate, attachments } = params

        if (attachments) {
          await attachments.map((file) => {
            form.append('attachments', file)
          })
        }

        const headers = {
          'Content-Type': 'multipart/form-data'
        }

        form.append('subject', subject)
        form.append('message', message)
        form.append('startDate', startDate)
        form.append('endDate', endDate)

        const announcement = await axios.post(
          `${process.env.VUE_APP_API_URL}/announcements`,
          form,
          {
            headers: headers,
            withCredentials: true
          }
        )

        return announcement
      } catch (err) {
        let response =
          'There was a problem with your request. Please try again later.'
        if (err.response.status === 415) {
          response =
            'Unsupported File Type. Please select an image (.jpg, .png)'
        } else if (err.response.status === 413) {
          response = 'File size too large. Please limit your file to 2MB.'
        }
        return Promise.reject(response)
      }
    }
  }
}
